module.exports = __webpack_public_path__ + "static/media/name.6516c65b.svg";